module.exports = __webpack_public_path__ + "static/media/carp.madera.0048f6f5.png";